import React from 'react';
import Logo from '@images/brand/rp-icon.svg';

const PageLoaderOverlay = React.memo(() => {
    return <div className="fixed z-50 h-full w-full bg-gray-200">
        <span className="flex items-center justify-center h-full">
            <div role="status">
                <Logo className="h-24 w-24"/>
                <span className="sr-only">Loading...</span>
            </div>
        </span>
    </div>
})

export default PageLoaderOverlay;